'use strict';

export default function PreviewGroupNewController(
  CreativeService,
  DataService,
  FlashService,
  PreviewGroupService,
  $state,
  MixpanelService
) {
  var vm = this;
  vm.creativeService = CreativeService;
  vm.dataService = DataService;
  vm.reset = reset;
  vm.toggleDemo = toggleDemo;
  vm.saveGroup = saveGroup;
  vm.demos = [];

  if (DataService.userCreatives.length == 0) {
    DataService.updateUserCreatives().then(setInitialCreative);
  } else {
    setInitialCreative();
  }

  function setInitialCreative() {
    CreativeService.setCreative(DataService.userCreatives[0]);
  }

  function reset() {
    vm.demos = [];
    vm.name = '';

    DataService.userCreatives.forEach(function(creative) {
      creative.checked = false;
    });
  }

  function toggleDemo(previewId) {
    var index = vm.demos.indexOf(previewId);

    if (index === -1) {
      vm.demos.push(previewId);
    } else {
      vm.demos.splice(index, 1);
    }
  }

  function successfulCreate(response) {
    FlashService.push('success', 'Your group has been saved.');

    MixpanelService.track('Demo Group Created', {
      demoGroupId: response.data.id
    });

    $state.go('creativePreview.showPreviewGroup', {
      id: response.data.id
    });
  }

  function failedCreate() {
    FlashService.push('error', 'Something went wrong.');
  }

  function saveGroup() {
    var namePresent = vm.name && vm.name.length > 0;

    if (namePresent > 0 && vm.demos.length > 0) {
      PreviewGroupService.create(vm.demos, vm.name).then(
        successfulCreate,
        failedCreate
      );
    } else {
      FlashService.push(
        'error',
        'Please select at least 1 demo and name your group.'
      );
    }
  }

  return vm;
}

PreviewGroupNewController.$inject = [
  'CreativeService',
  'DataService',
  'FlashService',
  'PreviewGroupService',
  '$state',
  'MixpanelService'
];
